import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { badgeVariants, type BadgeProps } from './variants';

/**
 * Small label / tag used for status indicators, market links, and bet values.
 *
 * @example
 * ```tsx
 * <Badge variant="default">Bitcoin</Badge>
 * <Badge variant="accent">7 Markets</Badge>
 * <Badge variant="success">+ $5</Badge>
 * <Badge variant="danger">+ $3</Badge>
 * ```
 */
const Badge = forwardRef<HTMLSpanElement, BadgeProps>(({ className, variant, ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
));
Badge.displayName = 'Badge';

export { Badge };
